<template>
  <section
    :class="
      cn(`flex items-center justify-center h-full w-full relative`, props.class)
    "
    :style="mergedStyle"
  >
    <div class="w-full h-full" />
  </section>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

export interface GridProps {
  lineWidth?: number
  gap?: number
  baseColor?: string
  activeColor?: string
  proximity?: number
  speedTrigger?: number
  shockRadius?: number
  shockStrength?: number
  maxSpeed?: number
  resistance?: number
  returnDuration?: number
  class?: HTMLAttributes['class']
  style?: HTMLAttributes['style']
}

const props = withDefaults(defineProps<GridProps>(), {
  lineWidth: 1,
  gap: 62.4, // 3.9rem in pixels (assuming 16px base)
  baseColor: '#f8f2f6',
  activeColor: '#ede6eb',
  proximity: 150,
  speedTrigger: 100,
  shockRadius: 250,
  shockStrength: 5,
  maxSpeed: 5000,
  resistance: 750,
  returnDuration: 1.5,
  class: undefined,
  style: undefined
})

const baseStyle = computed<HTMLAttributes['style']>(() => {
  const gap = Math.max(1, props.gap)
  const lineWidth = Math.max(1, props.lineWidth)
  const baseColor = props.baseColor

  // Two repeating gradients: vertical + horizontal lines.
  return {
    backgroundImage: `linear-gradient(to right, ${baseColor} ${lineWidth}px, transparent ${lineWidth}px), linear-gradient(to bottom, ${baseColor} ${lineWidth}px, transparent ${lineWidth}px)`,
    backgroundSize: `${gap}px ${gap}px`,
    backgroundPosition: '0 0',
    backgroundRepeat: 'repeat',
    pointerEvents: 'none'
  }
})

const mergedStyle = computed<HTMLAttributes['style']>(() => {
  if (!props.style) return baseStyle.value
  return [baseStyle.value, props.style]
})
</script>
